import { Component, OnInit, Input, EventEmitter, Output, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Client } from 'src/app/client-management/models/client.interface';
import { ClientService } from 'src/app/client-management/services/client.service';
import { debounceTime } from 'rxjs/operators';
import {Observable, Subscription} from 'rxjs';
import {SearchService} from '../search-service';

@Component({
  selector: 'app-search-clients',
  templateUrl: './search-clients.component.html',
  styleUrls: ['./search-clients.component.scss']
})
export class SearchClientsComponent implements OnInit, OnChanges, OnDestroy {

  @Input() client: Client = new Client();
  @Output() selectedClient = new EventEmitter<Client>();
  @Input() disabled: boolean;
  @Input() preventAutoFocus: boolean = false;
  clientSearch = new FormControl();
  clientResults: Client[] = [];
  filteredOptions: Observable<Client[]>;
  subscription: Subscription = new Subscription();
  
  constructor(
    public clientService: ClientService,
    private searchService: SearchService
  ) { }

  ngOnInit() {
    if (this.disabled) {
      this.clientSearch.disable();
    }

    this.subscription.add(
      this.clientSearch.valueChanges.pipe(debounceTime(500)).subscribe(this.searchClients.bind(this))
    );
    
    this.clientSearch.setValue(this.client.name || '', {emitEvent: false});
    this.filteredOptions = this.searchService.searchClientsResultObservable;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.client && this.clientSearch) {
      if (this.client && this.client.id !== '') {
        this.clientSearch.setValue(this.client.name, {emitEvent: false});
        if (this.disabled) {
          this.clientSearch.disable();
        }
      } else {
        this.clientSearch.setValue('', {emitEvent: false});
        if (!this.client || !this.client.name) {
          this.searchService.searchClients('');
        }
      }
    }
    
    if (changes.disabled && this.clientSearch) {
      if (this.disabled) {
        this.clientSearch.disable();
      } else {
        this.clientSearch.enable();
      }
    }
  }

  searchClients(value: string) {
    if (typeof value !== 'string') {
      return;
    }
    if (value === '') {
      this.client = new Client();
      this.selectedClient.emit(this.client);
    }
    this.searchService.searchClients(value);
  }

  selectClient(client: Client) {
    this.client = client as Client;
    this.selectedClient.emit(this.client);
    this.clientSearch.setValue(this.client.name, {emitEvent: false});
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
